<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <vue-multiselect v-model="modelValue" :placeholder="placeholder" :max-height="150" :options="options"
                     :multiple="true" :taggable="true" @tag="addTag" :close-on-select="false" :show-no-options="false"
                     :select-label="$t('multiselect.press-enter')"
                     :deselect-label="$t('multiselect.remove-enter')" :tag-placeholder="$t('multiselect.add-tag')"
    />
    <hint :hint="hint"></hint>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import debounce from 'lodash/debounce'
import Hint from '@/Shared/Hint'

export default {
  name: 'SelectTags',
  components: {VueMultiselect, Hint},
  props: {
    modelValue: Array,
    id: {
      type: String,
    },
    value: Object,
    label: String,
    error: String,
    placeholder: String,
    hint: String
  },
  data() {
    return {
      loading: false,
      selected: this.value,
      options: [],
    }
  },
  mounted() {
    if (this.modelValue) {
      this.options = this.modelValue
    }
  },
  setup(props, context) {
    const updateValue = (event) => {
      context.emit('update:modelValue', event)
    }
    return {updateValue}
  },
  watch: {
    modelValue(selected) {
      this.updateValue(selected)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    handleSearch: debounce(function (searchQuery) {
      this.fetchData(searchQuery)
    }, 500),
    addTag(newTag) {
      this.options.push(newTag)
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
